import ContatoResponse from '../entities/Contato'
import { IContatoRepository } from '../repositories/IContatosRepository'

export interface IContato {
  execute(): Promise<ContatoResponse[]>
}

export default class BuscarContatos implements IContato {
  constructor(private readonly contatoRepository: IContatoRepository) {}

  public async execute(): Promise<ContatoResponse[]> {
    const response = await this.contatoRepository.getContato()

    return response
  }
}
